import AbstractExpressGateway from './AbstractExpressGateway';

class GooglePayGateway extends AbstractExpressGateway {

    type = 'googlePay';

    constructor(props) {
        super(props);
        this.capabilities = [
            ...this.capabilities,
            'button_theme',
            'button_type',
            'form_validation'
        ];
    }
}

export default GooglePayGateway;